import React from "react";
import CustomModal from "./CustomModal";
import { MdClose } from "react-icons/md";

const UpdateConfirmModal = ({ open, onClose, onConfirm, isUpdating = false }) => {
  return (
    <CustomModal open={open} onClose={onClose} panelClass="md:max-w-xl max-w-2xl sm:w-full" zIndexClass="z-[99999]">
      <div className="flex w-full items-center justify-between mb-5 gap-5 flex-wrap">
        <h4 className="flex justify-center font-bold">UPDATE AVAILABLE</h4>
        <button
          className="text-xl bg-canvas-primary/10 p-2 rounded-xl text-canvas-primary"
          onClick={onClose}
        >
          <MdClose />
        </button>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Updating may affect data that hasn't finished syncing yet. Please make sure any offline
        changes have synced before continuing.
      </p>
      <div className="flex justify-end items-center gap-x-2">
        <button
          type="button"
          className="py-3 px-6 rounded-lg text-sm font-bold text-canvas-primary disabled:opacity-50"
          onClick={onClose}
          disabled={isUpdating}
        >
          CANCEL
        </button>
        <button
          type="button"
          className="shadow bg-canvas-primary text-white font-bold py-3 px-6 rounded-lg text-sm disabled:opacity-60"
          onClick={onConfirm}
          disabled={isUpdating}
        >
          {isUpdating ? "UPDATING..." : "UPDATE NOW"}
        </button>
      </div>
    </CustomModal>
  );
};

export default UpdateConfirmModal;
